import React from "react";
import { Crud } from "../../../../core/components/crud/Crud";
import { list, get } from "../../../../client/api/branchedStory";
import { branchedStoriesCRUDModel } from "../model";
import { BranchedStoryType, BranchedStoryListParameters } from "../../../../client/api/branchedStory";
import { useAuth } from "../../../../contexts/auth.context";
import { Navigate } from "react-router-dom";
import { CreateBranchedStoryWizard } from "../wizard/CreateBranchedStoryWizard";
import { BranchedStoryDetailsScreen } from "./BranchedStoryDetailsScreen";
import { update } from "../../../../client/api/branchedStory";
import "../BranchedStoriesTable.css";

export const BranchedStoriesScreen = (): JSX.Element => {
    const { user, hasPermission } = useAuth();

    if (!user) {
        return <Navigate to={"/403"} />;
    }

    return (
        <Crud<BranchedStoryType, BranchedStoryListParameters>
            model={branchedStoriesCRUDModel}
            noun="BranchedStory"
            plural="Branched Stories"
            getData={list}
            getItem={get}
            updateItem={update}
            labelProperty={"storyName"}
            searchable
            addComponent={CreateBranchedStoryWizard}
            editComponent={CreateBranchedStoryWizard}
            viewOnClick
            viewComponent={BranchedStoryDetailsScreen}
            canAdd={hasPermission("StoryCreate")}
        />
    );
};

export default BranchedStoriesScreen;
